interface Props {
  resolution: string
  setResolution: (r: string) => void
  totalShots: number
  doneCount: number
  hasApiKey: boolean
  onRefresh: () => void
  onGenerateAll: () => void
}

export function GenerateControls({
  resolution,
  setResolution,
  totalShots,
  doneCount,
  hasApiKey,
  onRefresh,
  onGenerateAll,
}: Props) {
  return (
    <div className="flex items-center gap-3 px-5 py-3 bg-forge-obsidian border-b border-forge-border">
      {/* Stats */}
      <div className="flex items-center gap-5">
        <Stat value={totalShots} label="Shots" />
        <Stat value={doneCount} label="Generated" color="text-forge-green" />
      </div>

      <div className="h-6 w-px bg-forge-border mx-2" />

      {/* API badge */}
      {hasApiKey ? (
        <span className="text-[10px] font-semibold px-2.5 py-1 rounded-full bg-forge-green/10 text-forge-green">
          API Key Set
        </span>
      ) : (
        <span className="text-[10px] font-semibold px-2.5 py-1 rounded-full bg-forge-heat-critical/10 text-forge-heat-critical">
          API Key Missing
        </span>
      )}

      <div className="flex-1" />

      {/* Resolution */}
      <label className="text-[11px] text-forge-ash">Resolution</label>
      <select
        value={resolution}
        onChange={(e) => setResolution(e.target.value)}
        className="bg-forge-basalt border border-forge-border text-forge-primary px-2 py-1 rounded-md text-[12px] focus:outline-none focus:border-forge-ember"
      >
        <option value="720p">720p</option>
        <option value="1080p">1080p</option>
        <option value="4k">4K</option>
      </select>

      {/* Actions */}
      <button
        onClick={onRefresh}
        className="text-[11px] font-semibold text-forge-ash border border-forge-border rounded-md px-3 py-1.5 hover:bg-forge-basalt transition-colors"
      >
        Refresh Scripts
      </button>
      <button
        onClick={onGenerateAll}
        disabled={!hasApiKey}
        className="text-[11px] font-semibold bg-forge-ember text-white rounded-md px-4 py-1.5 hover:bg-forge-ember/80 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Generate All Shots
      </button>
    </div>
  )
}

function Stat({ value, label, color }: { value: number; label: string; color?: string }) {
  return (
    <div className="text-center">
      <div className={`text-lg font-bold font-display leading-none ${color || 'text-forge-ember'}`}>
        {value}
      </div>
      <div className="text-[9px] text-forge-ash uppercase tracking-wider mt-0.5">{label}</div>
    </div>
  )
}
